package com.leakingcode.fikit.api.model

import kotlinx.serialization.Serializable

@Serializable
data class TickerApiModel(val code: String)

@Serializable
data class TickersApiModel(val tickers: List<TickerApiModel>)
